import React from 'react';
import { Language } from '../../pages/DevPortal';

export default function ApiSection({ lang }: { lang: Language }) {
    const isEn = lang === 'en';

    return (
        <div className="animate-fade-in">
            <h1 className="text-3xl font-bold text-slate-900 mb-4">
                {isEn ? 'REST API Reference' : 'Referencia de la API REST'}
            </h1>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
                {isEn 
                    ? `The Hospital Status API is organized around REST. Base URL: ${window.location.origin}/api`
                    : `La API de Hospital Status sigue principios REST. Base URL: ${window.location.origin}/api`}
            </p>

            <div className="space-y-10">
                
                {/* Endpoint 1 */}
                <div>
                    <h2 className="text-xl font-bold text-slate-900 mb-4 border-b border-slate-200 pb-2">Patients API</h2>
                    
                    <div className="border border-slate-200 rounded-lg mb-4 bg-white overflow-hidden">
                        <div className="bg-slate-50 border-b border-slate-200 px-4 py-3 flex items-center gap-3">
                            <span className="bg-emerald-100 text-emerald-800 text-xs font-mono font-bold px-2 py-0.5 rounded">POST</span>
                            <code className="text-sm font-bold text-slate-700">/patients</code>
                            <span className="ml-auto text-xs text-slate-400 font-medium border border-slate-200 rounded-full px-2 py-0.5 bg-white">
                                {isEn ? 'Requires Auth' : 'Requiere Auth'}
                            </span>
                        </div>
                        <div className="p-4 bg-slate-900 text-slate-300 font-mono text-xs overflow-x-auto">
{`// Create Patient Payload
{
  "name": "Juan Perez",
  "procedureName": "Artroscopia",
  "room": "room_id_123"
}`}
                        </div>
                    </div>

                    <div className="border border-slate-200 rounded-lg mb-4 bg-white overflow-hidden">
                        <div className="bg-slate-50 border-b border-slate-200 px-4 py-3 flex items-center gap-3">
                            <span className="bg-amber-100 text-amber-800 text-xs font-mono font-bold px-2 py-0.5 rounded">PUT</span>
                            <code className="text-sm font-bold text-slate-700">/patients/:id</code>
                        </div>
                        <div className="p-4 bg-slate-900 text-slate-300 font-mono text-xs overflow-x-auto">
{`// Update Patient Status Payload
{
  "currentStatus": "SURGERY",
  "currentSubStatus": "INCISION",
  "surgeryProgress": 30
}`}
                        </div>
                    </div>
                </div>

                {/* Endpoint 2 */}
                <div>
                    <h2 className="text-xl font-bold text-slate-900 mb-4 border-b border-slate-200 pb-2">Real-Time Streams (SSE)</h2>
                    
                    <div className="border border-slate-200 rounded-lg mb-4 bg-white overflow-hidden">
                        <div className="bg-slate-50 border-b border-slate-200 px-4 py-3 flex items-center gap-3">
                            <span className="bg-blue-100 text-blue-800 text-xs font-mono font-bold px-2 py-0.5 rounded">GET</span>
                            <code className="text-sm font-bold text-slate-700">/patients/stream?hospitalId=X</code>
                            <span className="ml-auto text-xs text-slate-400 font-medium">text/event-stream</span>
                        </div>
                        <div className="p-4">
                            <p className="text-sm text-slate-600">
                                {isEn 
                                    ? 'Subscribes to live patient updates for a specific hospital. Returns heartbeat every 15s to keep connection alive.'
                                    : 'Subscripción a eventos en tiempo real de pacientes para un hospital específico.'}
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}
